<template>
    <div class="vx-row">
        <div class="vx-col xl:w-1/3 lg:w-1/2 w-full mb-6">
            <vx-card id="terminalDiv" class="vs-con-loading__container">


                <div class="flex">
                    <h5 class="mt-1 mr-6">{{$t('Status')}}: </h5>
                    <vs-chip v-if="terminal.status === 0" color="danger">
                        {{$t('Offline')}}
                    </vs-chip>
                    <vs-chip v-else color="success">
                        {{$t('Online')}}
                    </vs-chip>
                </div>

                <div>
                    <h5 class="mt-6 mr-6">{{ $t('AccessCode') }}: </h5>
                    <p class="w-full" style="word-wrap: break-word">{{terminal.access_code}}</p>
                </div>

                <vs-divider/>
                <vs-checkbox class="mt-3" v-model="terminal.exit_only">{{ $t('UnconditionalExit') }}</vs-checkbox>
                <p class="mt-6">{{ $t('TerminalName') }}</p>
                <vs-input class="w-full" v-model="terminal.name"/>
                <p class="mt-6">{{ $t('ActuationLength') }}</p>
                <vs-input class="w-full" v-model="terminal.actuation_length"/>
                <p class="mt-6">{{ $t('ActuationType') }}</p>
                <vs-select autocomplete class="w-full" v-model="terminal.actuation_type">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in actuationTypes" />
                </vs-select>
                <p class="mt-6">{{ $t('ActuationTerminal') }}</p>
                <vs-select autocomplete class="w-full" v-model="terminal.actuation_terminal_id">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in [{id: 0, name: $t('ThisTerminal')}].concat(terminals)" />
                </vs-select>
                <vs-divider/>
                <vs-button style="float: left" color="warning" icon-pack="feather" icon="icon-save" class="mb-3 mr-3" @click="saveTerminal">{{ $t('Save') }}</vs-button>
                <vs-button style="float: left" color="danger" icon-pack="feather" icon="icon-save" class="mb-3" @click="removeTerminal">{{ $t('Remove') }}</vs-button>

            </vx-card>
        </div>

        <div class="vx-col xl:w-2/3 lg:w-1/2 w-full">
            <access-table :data-u-r-l="`/api/management/v1/access_terminal/${this.$route.params.id}/access`"/>
        </div>


        <vs-divider/>
    </div>
</template>
<script>
    import AccessTable from '@/views/Access/AccessTable'
    export default {
        components: { AccessTable },
        data() {
            return {

                terminal: {
                    name: '',
                    access_code: '',
                    actuation_type: 0,
                    actuation_terminal_id: 0,
                    actuation_length: 0,
                    exit_only: false,
                    last_ping_time: new Date(),
                    status: 0
                },

                terminals: [],

                actuationTypes: [
                    {
                        id: 0,
                        name: this.$t('Relay')
                    },
                    {
                        id: 1,
                        name: this.$t('GPIO')
                    }
                ]

            }
        },
        methods: {
            loadData() {
                this.$vs.loading({
                    container: '#terminalDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get(`/api/management/v1/access_terminal/${this.$route.params.id}`)
                loadPromise.then(function(response) {
                    thisIns.terminal = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const terminalsPromise = this.$http.get('/api/management/v1/access_terminal/')
                terminalsPromise.then(function(response) {
                    thisIns.terminals = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                Promise.all([loadPromise, terminalsPromise]).finally(function() {
                    thisIns.$vs.loading.close('#terminalDiv > .con-vs-loading')
                })
            },
            saveTerminal() {
                this.$vs.loading({
                    container: '#terminalDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const addPromise = this.$http.put(`/api/management/v1/access_terminal/${this.$route.params.id}`, {
                    name: this.terminal.name,
                    actuation_type: Number(this.terminal.actuation_type),
                    actuation_terminal_id: Number(this.terminal.actuation_terminal_id),
                    actuation_length: Number(this.terminal.actuation_length),
                    exit_only: this.terminal.exit_only
                })

                addPromise.then(function() {
                    thisIns.$printSuccess(thisIns.$t('TerminalSaved'))
                    thisIns.loadData()
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#terminalDiv > .con-vs-loading')
                })
            },
            removeTerminal() {
                this.$vs.loading({
                    container: '#terminalDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const removePromise = this.$http.delete(`/api/management/v1/access_terminal/${this.$route.params.id}`)
                removePromise.then(function() {
                    thisIns.$printSuccess(thisIns.$t('TerminalRemoved'))
                    thisIns.$nextTick(() => {
                        thisIns.$router.push('/terminals')
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#terminalDiv > .con-vs-loading')
                })
            }
        },
        mounted() {
            this.loadData()
        }
    }
</script>
